module.exports = __webpack_public_path__ + "static/img/img5.dc3384f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img5.png
// module id = wLWT
// module chunks = 0